<template>
  <transition name="v">
    <router-view/>
  </transition>
</template>


<script>

// import { ref } from 'vue'
import axios from 'axios'
// import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'


export default {

name: 'App',
components: {
    
},
data() {

    return {
        name_level: [{ id: 1, name: 'Кронштадт' }],
        progress_bar_val: 5,
        progress_circle_val: 60,
        date_load: [],
        data_claster: [],
        data_claster_block: [],
        posts_test_claster_stroki: [],
        posts_summer_fact: [],
        posts_summer_plan: [],
        // arr_pokasatel:["Производство","Разработано КД", "Новые клиенты", "Продано стандартов внутренним клиентам"]
        arr_pokasatel:[""],
        pokazatel_otstavania: [],
        state: [{date: new Date(2016, 9,  16)}],
        // var arr = [{a: 1}];
        // arr.push({b: 2});
        // < [{a: 1}, {b: 2}]
        // filtr_pokazatel_claster:[{"name":"Запчасти и комплектующие", "data":["Выручка", "Разработано КД", "Новые клиенты", "Производство"]}]
        filtr_pokazatel_claster:[],
        arr_pokasatel_arr: [],

    }
},



methods: {
    async fetchPosts_test_claster_block() {
        try{

            this.isPostsLoading = true
            // const response = await axios.get('http://127.0.0.1:8000/api/BlockObespechTovars');
            const response_cl = await axios.get(this.dynamicPort + '/get_claster');
            const response_bl = await axios.get(this.dynamicPort + '/get_claster_block');
            const response_st = await axios.get(this.dynamicPort + '/get_claster_stroki');
            this.data_claster_block = response_bl.data;

            for (var cl=0; cl<=response_cl.data.length-1; cl++) {
              let arr_pokazat = [];
              for (var bl=0; bl<=response_bl.data.length-1; bl++){
                for (var st=0; st<=response_st.data.length-1; st++){
                if (response_cl.data[cl].id === response_st.data[st].claster_id 
                    && response_st.data[st].metric != "Выручка"
                    && response_cl.data[cl].id === response_bl.data[bl].claster_id 
                    && response_bl.data[bl].id === response_st.data[st].claster_id
                  ){
                  arr_pokazat.push(response_st.data[st].metric)
                }
              }
              }
              
              
              let arr_metrics = [];
              for (var bl=0; bl<=response_bl.data.length-1; bl++){
                if (response_cl.data[cl].id === response_bl.data[bl].claster_id)
                  // name_clasters
                  // console.log(response_bl.data[bl].name)
                  // console.log(this.$store.state.metric_filtr[1])
                  arr_metrics.push(response_bl.data[bl].name)
                                    
              }
              // console.log(arr_metrics)
              // console.log(arr_pokazat.slice(1, 3))
              
              // this.$store.state.metric_filtr.push({'claster_id':response_cl.data[cl].id,'name_claster':response_cl.data[cl].name, 'metrics': [arr_metrics]})
              // this.$store.state.metric_filtr_check_box.push(arr_pokazat.slice(0, 2)[0])
              // this.$store.state.metric_filtr_check_box.push(arr_pokazat.slice(0, 2)[1])
               
            }
            console.log(this.$store.state.metric_filtr_check_box)

        // console.log($store.state.metric_filtr_check_box)
          
            
        } catch (e) {
            // alert("Error")
        }
    },
    async fetchPosts_dinamic_claster() {
                this.$store.state.categories = [];
                this.$store.state.categories_checked = [];
                
                const response_get_claster = await axios.get(this.dynamicPort + '/get_claster');
                
                // Сортируем данные по critical_flag (по возрастанию, "0" будут первыми)
                const sortedData = response_get_claster.data.sort((a, b) => {
                    return Number(a.critical_flag) - Number(b.critical_flag);
                });
                
                for (var cl = 0; cl < sortedData.length; cl++) {
                    this.$store.state.categories.push(sortedData[cl]['name']);
                    this.$store.state.categories_checked.push(sortedData[cl]['name']);
                }
            },
    
},


mounted() {
    // this.fetchPosts_test_claster_block();
    // this.fetchPosts_dinamic_claster();
    // this.fetchPosts_test_claster_stroki();
    
    // this.fetchPosts_count_sum();
    
    
    // this.focusInput()
},
computed: {
          dynamicPort() {
            return this.$store.state.year_change === 2025
              ? "/api/dashboard"
              : "/api/dashboard";
          }
        },



}


</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
    background-color: #000;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
@import '../public/style.css';
</style>
